<!-- Search -->
  <div nxRow nxRowJustify="start,start,around">
    <div nxCol="12,10">
      <div nxLayout="grid" class="nx-margin-top-s">
        <div nxRow>
          <div nxCol="4">
            <nx-formfield>
              <input nxInput placeholder="Search by reference" [(ngModel)]="searchTerm" type="search" />
              <span nxFormfieldPrefix><nx-icon name="search" size="s"></nx-icon></span>
              <span nxFormfieldSuffix *ngIf="searchTerm" aria-hidden="true" (click)="searchTerm=''; getInvoiceList()">
                <nx-icon name="close" size="s"></nx-icon>
              </span>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="Start Date">
              <input nxDatefield nxInput [nxDatepicker]="startDatepicker" [(ngModel)]="startDate" />
              <nx-datepicker-toggle [for]="startDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #startDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="End Date">
              <input nxDatefield nxInput [nxDatepicker]="endDatepicker" [(ngModel)]="endDate" />
              <nx-datepicker-toggle [for]="endDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #endDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="4" class="nx-margin-top-2xs" style="display:flex; gap:8px; align-items:flex-start; flex-wrap:wrap;">
            <button nxButton="primary small-medium" type="button" (click)="pageNumber=1; getInvoiceList()">Search</button>
            <button nxButton="secondary small-medium" type="button" (click)="exportToExcel()">
              <nx-icon name="file-spreadsheet" class="nx-margin-right-2xs"></nx-icon>Export
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- Table -->
  <div nxRow nxRowJustify="start,start,around">
    <div nxCol="12,10">
      <table nxTable zebra condensed nxSort (sortChange)="sortTable($event)" class="nx-margin-top-s">
        <thead>
          <tr nxTableRow>
            <th nxHeaderCell nxSortHeaderCell="referenceNo">Reference No.</th>
            <th nxHeaderCell nxSortHeaderCell="invoiceMonth">Invoice Period</th>
            <th nxHeaderCell nxSortHeaderCell="uploadedOn">Raised On</th>
            <th nxHeaderCell>AWP Comments</th>
            <th nxHeaderCell>My Dispute Comment</th>
            <th nxHeaderCell nxSortHeaderCell="status">Status</th>
            <th nxHeaderCell>Actions</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr nxTableRow *ngFor="let item of invoiceList">
            <td nxTableCell>{{ item.referenceNo }}</td>
            <td nxTableCell>{{ months[item.invoiceMonth - 1] }} {{ item.invoiceYear }}</td>
            <td nxTableCell>{{ item.submittedOn | date:'dd/MM/yyyy' }}</td>
            <td nxTableCell class="comment-cell">{{ item.comments }}</td>
            <td nxTableCell class="comment-cell">
              <span *ngIf="item.disputeComment; else noDispute">{{ item.disputeComment }}</span>
              <ng-template #noDispute><span class="no-comment">—</span></ng-template>
            </td>
            <td nxTableCell>
              <nx-badge [type]="badgeType(item.status)">{{ item.status }}</nx-badge>
            </td>
            <td nxTableCell>
              <nx-context-menu #menu="nxContextMenu">
                <ng-template nxContextMenuContent>
                  <button nxContextMenuItem type="button" (click)="downloadInvoice(item.id, item.referenceNo)">
                    <nx-icon name="download" class="nx-margin-right-2xs"></nx-icon>Download Invoice
                  </button>
                  <button nxContextMenuItem type="button" *ngIf="item.status !== 'Approved'"
                    (click)="openDisputeModal(item)">
                    <nx-icon name="comment-o" class="nx-margin-right-2xs"></nx-icon>
                    {{ item.disputeComment ? 'Edit Comment' : 'Raise Dispute' }}
                  </button>
                  <button nxContextMenuItem type="button" *ngIf="item.adminComments"
                    (click)="openReviewModal(item)">
                    <nx-icon name="info-circle-o" class="nx-margin-right-2xs"></nx-icon>View Review
                  </button>
                </ng-template>
              </nx-context-menu>
              <button nxIconButton="tertiary medium" type="button" [nxContextMenuTriggerFor]="menu"
                aria-label="Open menu" nxTooltip="Actions" nxTooltipPosition="top">
                <nx-icon aria-hidden="true" name="ellipsis-h"></nx-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

<div *ngIf="count === 0" class="nx-margin-top-2xl">
  <div nxRow nxRowJustify="center">
    <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">No Records found !!!</h3>
  </div>
</div>

<div nxRow style="float: right" *ngIf="count > 0">
  <div nxCol="12">
    <nx-pagination
      [nxCount]="count"
      [nxPage]="pageNumber"
      [nxPerPage]="pageSize"
      nxType="advanced"
      (nxGoPrev)="prevPage()"
      (nxGoNext)="nextPage()"
      (nxGoPage)="goToPage($event)"
    ></nx-pagination>
  </div>
</div>

<!-- ===================== Review Details Modal ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="reviewModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid" *ngIf="selectedInvoice">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">Dispute Review Result</h3>
        <p nxCopytext="small" class="nx-margin-bottom-s">
          Reference: <strong>{{ selectedInvoice.referenceNo }}</strong> &mdash;
          {{ months[selectedInvoice.invoiceMonth - 1] }} {{ selectedInvoice.invoiceYear }}
        </p>
      </div>
    </div>

    <div nxRow>
      <div nxCol="12">
        <nx-label class="nx-margin-bottom-2xs">Decision</nx-label>
        <div class="nx-margin-bottom-s">
          <nx-badge [type]="badgeType(selectedInvoice.status)">{{ selectedInvoice.status }}</nx-badge>
        </div>
      </div>
    </div>

    <div nxRow>
      <div nxCol="12">
        <nx-label class="nx-margin-bottom-2xs">AWP Review Comment</nx-label>
        <div class="readonly-comment nx-margin-bottom-s">{{ selectedInvoice.adminComments || '—' }}</div>
      </div>
    </div>

    <div nxRow>
      <div nxCol="12">
        <nx-label class="nx-margin-bottom-2xs">Your Dispute Comment</nx-label>
        <div class="readonly-comment nx-margin-bottom-s">{{ selectedInvoice.disputeComment || '—' }}</div>
      </div>
    </div>

    <div nxRow class="nx-margin-top-s">
      <div nxCol="12">
        <button nxButton="block secondary" type="button" (click)="closeReviewModal()">Close</button>
      </div>
    </div>
  </div>
</nx-modal>

<!-- ===================== Dispute Comment Modal ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="disputeModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid" *ngIf="selectedInvoice">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">Raise Dispute Comment</h3>
        <p nxCopytext="small" class="nx-margin-bottom-s">
          Reference: <strong>{{ selectedInvoice.referenceNo }}</strong> &mdash;
          {{ months[selectedInvoice.invoiceMonth - 1] }} {{ selectedInvoice.invoiceYear }}
        </p>
      </div>
    </div>

    <div nxRow>
      <div nxCol="12">
        <nx-label class="nx-margin-bottom-2xs">AWP Admin Comments</nx-label>
        <div class="readonly-comment nx-margin-bottom-s">{{ selectedInvoice.comments || '—' }}</div>
      </div>
    </div>

    <div nxRow>
      <div nxCol="12">
        <nx-label class="nx-margin-bottom-2xs">AWP Review Comment</nx-label>
        <div class="readonly-comment nx-margin-bottom-s">{{ selectedInvoice.adminComments || '—' }}</div>
      </div>
    </div>

    <form [formGroup]="disputeForm">
      <div nxRow>
        <div nxCol="12">
          <nx-formfield nxLabel="Your Dispute Comment">
            <textarea nxInput formControlName="disputeComment" rows="4"
              placeholder="Describe your dispute or clarification regarding this invoice..."></textarea>
            <nx-error nxFormfieldError="required">Please enter your dispute comment.</nx-error>
            <nx-error nxFormfieldError="maxlength">Comment cannot exceed 1000 characters.</nx-error>
          </nx-formfield>
        </div>
      </div>
    </form>

    <div nxRow class="nx-margin-top-s">
      <div nxCol="6">
        <button nxButton="block primary" type="button"
          [disabled]="disputeInProgress"
          (click)="submitDisputeComment()">
          {{ disputeInProgress ? 'Saving...' : 'Submit Comment' }}
        </button>
      </div>
      <div nxCol="6">
        <button nxButton="block secondary" type="button" (click)="closeDisputeModal()">Cancel</button>
      </div>
    </div>
  </div>
</nx-modal>
